<template>
  <div class="scene">

    <div class="help">
      <div class="help-cen">
        <h1>帮助中心与常见问题</h1>
        <!-- <input type="text" placeholder="请输入关键字"> -->
        <p>帮助导航</p>
        <div class="help-list">
          <div>
             <p>
              <img src="../assets/product/control1.png" alt="">
              用户手册
             </p>
             <ul>
              <li @click="openUrl('https://help.liyeos.com/#/materialListHelp')">产品信息</li>
              <li @click="openUrl('https://help.liyeos.com/#/quotationListPageHelp')">报价信息</li>
              <li @click="openUrl('https://help.liyeos.com/#/sellerOrderHelp')">订单信息</li>
              <li @click="openUrl('https://help.liyeos.com/#/roleListHelp')">组织结构</li>
             </ul>
             <div class="line"></div>
             <a href="https://help.liyeos.com/#/help" target="_blank">查看更多</a>
          </div>
          <div>
             <p>
              <img src="../assets/product/control1.png" alt="">
              常见问题
             </p>
             <ul>
              <li v-for="(entries, date,index) in data['常见问题']"  v-if="index < 4" :key="date" @click="openRenew(entries, date,'常见问题')">{{ date }}</li>
             </ul>
             <ul>
              
             </ul>
             <div class="line"></div>
             <a href="http://192.168.1.111:8081/#/contents" target="_blank">查看更多</a>
          </div>
          <div>
             <p>
              <img src="../assets/product/control1.png" alt="">
              更新公告
             </p>
             <ul>
              <li v-for="(entries, date,index) in data['更新公告']"  v-if="index < 4" :key="date" @click="openRenew(entries, date,'更新公告')">{{ date }}更新详解</li>
             </ul>
             <div class="line"></div>
             <a href="http://192.168.1.111:8081/#/contents" target="_blank">查看更多</a>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import data from './content/renew.json'; // 根据实际路径导入 JSON 文件

export default {
  name: 'scene',
  data () {
    return {
      data: data // 将导入的 JSON 数据赋值给 data 属性
    }
  },
  created(){
  },
  computed:{
  },
  methods: {
    openRenew(entries,date,title) {
      let url = this.$router.resolve({
        path: '/contents',
        query: { title: title, details: JSON.stringify(entries), activeChild:date  }
      });
      window.open(url.href, '_blank');
    },
    openUrl(url) {
      window.open(url, "_blank");
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.scene{

}

.help {
  background: url(../assets/help/1.png);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
  height: 862px;
  padding-top: 120px;
  box-sizing: border-box;
}
.help-cen {
  width: 1460px;
  margin: 0 auto;
}
.help-cen > h1 {
  text-align: center;
  font-weight: bold;
  font-size: 36px;
  color: #3F3F3F;
}
.help-cen > input {
    width: 850px;
    height: 68px;
    background: #FFFFFF;
    border-radius: 34px;
    font-size: 24px;
    color: #3F3F3F;
    border: 1px solid #ccc;
    padding: 18px 18px 18px 48px;
    box-sizing: border-box;
    outline: none;
    margin: 46px auto 0;
    display: block;
}
.help-cen > p {
  font-weight: 500;
  font-size: 24px;
  color: #3F3F3F;
  font-style: normal;
  margin-top: 42px;
  margin-bottom: 35px;
}
.help-list {
  display: flex;
  justify-content: space-between;
}
.help-list > div {
  width: 460px;
  height: 346px;
  background: #FFFFFF;
  box-shadow: 4px 6px 8px 4px rgba(210,223,248,0.45);
  border-radius: 8px;
  padding-top: 36px;
  padding-left: 32px;
  box-sizing: border-box;
}
.help-list div p {
  font-weight: 500;
  font-size: 22px;
  color: #3F3F3F;
  margin-bottom: 8px;
}
.help-list div p img {
  width: 18px;
  height: 22px;
}
.help-list div ul {
  margin-left: 24px;
}
.help-list div ul li {
  font-weight: 400;
  font-size: 20px;
  color: #3F3F3F;
  line-height: 46px;
  position: relative;
  cursor: pointer;
}
.help-list div ul li::after {
  content: '';
  width: 6px;
  height: 6px;
  background: #D8D8D8;
  border-radius: 50%;
  position: absolute;
  left: -17px;
  top: 20px;
}
.line {
  width: 396px;
  height: 1px;
  background:  #D8D8D8;
  margin-top: 10px;
  margin-bottom: 20px;
}
.help-list div a {
  font-weight: 400;
  font-size: 16px;
  color: #2B77FF;
  position: relative;
}
.help-list div a::after {
  content: '';
  position: absolute;
  top: 50%;
  right: -18%;
  transform: translateY(-50%);
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-left: 6px solid #2B77FF;
}
</style>



// WEBPACK FOOTER //
// src/components/scene.vue